import React from "react";

export interface PaginationParams {
  offset: number;
  limit: number;
}

export interface Paginated<T> {
  items: T[];
  total: number;
}

export enum Area {
  Patients = "/patients",
  Therapists = "/therapists",
  Hcps = "/hcps",
  Login = "/login",
  Payers = "/payers",
  Auth = "/auth",
  Reports = "/reports",
  Other = "/other",
  RCM = "/RCM",
  Invoices = "/RCM/invoices",
  CDM = "/RCM/CDM",
  GenerateClaim = "/RCM/generateclaim",
  Logout = "/logout",
  Registry = "/other/registry",
  CareEventConfigurations = "/other/careEventConfigurations",
  UnclaimedMedicalReferrals = "/other/unclaimed_medical_referrals",
  UkReferralBatch = "/other/uk-referral-batch",
  UkReferralTracking = "/other/uk-referral-tracking",
  UkReports = "/other/uk-reports",
  HealthCareOrganizations = "/health-care-organizations",
  CreateContent = "/create-content",
  CreateContent_NewExercise = "/create-content/new-exercise",
  CreateContent_EditExercise = "/create-content/edit-exercise",
  CreateContent_Exercises = "/create-content/exercises",
  CreateContent_Templates = "/create-content/templates",
  Lessons = "/create-content/lessons",
  Lessons_New = "/create-content/lessons/new",
  Lessons_Edit = "/create-content/lessons/:id/edit",
  HealthForms = "/health-forms",
  HealthForms_Questionnaires = "/health-forms/questionnaires",
  HealthForms_Questionnaire = "/health-forms/questionnaires/:id",
  HealthForms_QuestionGroups = "/health-forms/question-groups",
  HealthForms_QuestionGroup = "/health-forms/question-groups/:id",
  HealthForms_Questions = "/health-forms/questions",
  HealthForms_Question = "/health-forms/questions/:id",
  HealthForms_Published = "/health-forms/published",
  HealthForms_PublishedDetail = "/health-forms/published/:id",
  Invitations = "/invitations",
  Medications = "/medications",
}

export interface HasId {
  id: number;
}

export interface WithChildren {
  children?: React.ReactNode;
}

export interface Meta {
  created_at: string;
  updated_at: string;
}

export type ArrayEm<T extends any[]> = T extends (infer R)[] ? R : never;
